/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Skeletonui from '../Components/Skeletonui'
import { useState, useEffect } from "react";
import Iframe from 'react-iframe'
   import {
     Card,
     CardHeader,
     CardBody,
     CardFooter,
     Typography,
    } from "@material-tailwind/react";
    


import { Link } from 'react-router-dom';

import { Avatar } from "@material-tailwind/react";
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
 import Paper from '@mui/material/Paper';
 import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ScrollToTop from "react-scroll-to-top"; 


import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem, 
} from "@material-tailwind/react";
 
 import {
  Drawer,
  Button,
   IconButton,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
 } from "@material-tailwind/react"; 
import { useNavigate} from "react-router-dom";
 

const Businessconsulting = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }, []);
    const navigate = useNavigate();
    return (
        <> 
         
         <nav class="fixed z-10 bg-black block w-full  px-4 py-5 mx-auto text-white bg-slate-800 shadow-md  mt-0">
         <div class="container flex flex-wrap items-center justify-between mx-auto">
       
          <button onClick={() => navigate(-1)}>  <i style={{fontSize:21}}  class="text-white fa-solid fa-arrow-left"></i>  </button>  
         
          <p className='text-white text-[18px]' >  Business & Consulting     </p>  
         
         <Link onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }} className="block text-teal-600" to="/">
                  
                    <button onClick={() => navigate(1)}
             class="relative ml-auto h-6 max-h-[40px] w-6 max-w-[40px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-inherit transition-all hover:bg-transparent focus:bg-transparent active:bg-transparent disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none lg:hidden"
             type="button">
             <i style={{fontSize:20}} class="text-white fa-solid fa-home"></i> 
           </button>
            
            </Link>
        
         </div> 
        
       </nav> <br></br> <br></br>  
{loading ? <Skeletonui />  :  

<>
<ScrollToTop smooth className="bg-none pl-[15px] pr-[44px]" color="blue" />

<div className="">
 
{loading ? <Skeletonui />  :  
 <Iframe url="https://sitekitpro.com/SITEKITPROREACT/catlog/all-sitekit-themes/index.html"
   width="100%"
   height="900px" 
   display="block"
   position="relative"/>   }

  {/*  Dextop Only  */}
  
 </div>
</>
 
}

  {/*  Dextop Only  */}
   
        </>
    );
}

export default Businessconsulting;
  